module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter01"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Design")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("t the end of the First World War Germany was humbled. Gone was the Hohenzollern dynasty to be replaced by the Weimer Republic. The determination of the allies, especially France, to take revenge on Germany proved short-sighted in the extreme, as all this achieved was to make the struggling German republic a breeding ground for seething resentment. The end product was Adolf Hitler. Imperial Germany had been a latecomer as a major naval power and the explosive growth of the Imperial German Navy had been one of the causes of the war. After the Armistice the High Seas Fleet was supposed to be interned in a neutral port pending a peace treaty, but this port turned out to be Scapa Flow, home of the Grand Fleet. While the British Fleet was at sea on manoeuvres most of the once-proud capital ships of the High Seas Fleet scuttled themselves rather endure a more shameful fate. The eventual peace treaty signed at Versailles included clauses restricting the development of any future German navy. As foreseen, all modern German warships were parcelled out among the victors and Germany was only left with a handful of obsolete predreadnought battleships.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Future construction was hamstrung by size constraints. Maximum displacement was set at 6000 tons for cruisers and at 10,000 tons for battleships. The Germans were allowed to replace their old predreadnought battleships on a one-for-one basis as each old battleship reached 20 years of age. Great Britain and France could not foresee Germany producing anything that could be considered a threat on a 10,000-ton displacement, but German naval architects took up this challenge and, by thinking outside of the box, came up with a unique answer. This was not a conventional battleship design but instead combined the armour of a cruiser with six 11in guns. Rated simply as a ‘panzerschiff’ (armoured ship), the first of a three-ship class was the "), _c('i', [_vm._v("Deutschland")]), _vm._v(". Arguably the most efficient German warship design, it provided a very powerful warship on a cruiser’s displacement. However, the Weimer Republic lied about the displacement from the start, as the final displacement was substantially over 10,000 tons. With extremely efficient diesel engines providing a top speed of 26 knots, the only ships with superior armament and the speed to run down the panzerschiffe were the three British battlecruisers. The diesel power plant produced a huge operational range of 10,000nm, making the ships the perfect commerce raider.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The British and French admiralties were totally confounded by the appearance of the panzerschiffe. Great Britain had no battleship tonnage left under the Washington Treaty for a reply, but France did and built the "), _c('i', [_vm._v("Strasbourg")]), _vm._v(" and "), _c('i', [_vm._v("Dunkerque")]), _vm._v(" as an answer to the panzerschiffe. The last true battlecruiser design, the pair did have the speed, armament and armour to defeat a panzerschiff. Germany had already built or ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("was building three of the type – "), _c('i', [_vm._v("Deutschland, Admiral Scheer")]), _vm._v(" and "), _c('i', [_vm._v("Admiral Graf Spee")]), _vm._v(" – and had plans for two more. The revelation of the French "), _c('i', [_vm._v("Strasbourg")]), _vm._v(" design, however, prompted a rethinking and the next two were to be improved panzerschiffe with far greater displacement. Although this design still carried six 11in guns, the armour protection and size greatly increased. With a design displacement of around 20,000 tons and a length of almost 700ft, it would have been impossible to claim that these ships were within the 10,000-ton Versailles limits. At the same time designers and admirals flirted with ways of providing heavier armament than the six 11in guns of their predecessors. One proposal was to provide two quadruple 11in guns along the lines of the mountings in the French battlecruisers; others were to match the 330mm (13in) guns of the French ships, or to mount 350mm (14in) and 380mm (15in) main armament. With any of these choices, a total redesign would be needed, substantially extending the design and construction process.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Gneisenau")]), _vm._v(" on 22 August 1938 off Kiel for the celebrations surrounding the launch of the cruiser "), _c('i', [_vm._v("Prinz Eugen")]), _vm._v(". At this time the ship was carrying out trials with various prototype floatplanes, the aircraft on the catapult being a Heinkel He 114. Note that as completed the ship carried a stump foremast stepped on the main director on the foretop.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("The newly completed "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" in April 1939. At this stage of her career, the ship looked very like her sister, with straight stem, mainmast on the funnel platform and no funnel cap. However, the ship carried her foremast stepped on the rear of the admiral’s platform from commissioning.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Even with this large expansion of the panzerschiff design, this pair would still have been inferior to the new French battlecruisers without the total redesign required for heavier main gun armament. Hitler had been in power since 1933 and had approved the orders for the two improved panzerschiffe. The contract for ‘Panzerschiffe D’ "), _c('i', [_vm._v("(Ersatz Elsass")]), _vm._v("), later "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(", was awarded to Marinewerft, Wilhelmshaven on 24 January 1934 as a six 11in gun improved "), _c('i', [_vm._v("Deutschland")]), _vm._v(". The same was true with ship ‘E’ "), _c('i', [_vm._v("(Ersatz Hessen)")]), _vm._v(", later "), _c('i', [_vm._v("Gneisenau")]), _vm._v(", ordered from Deutsche Werke, Kiel on 25 January 1934. The keels for both ships were laid down on 14 February 1934 but it was only a few months before work was stopped on these hulls. Further thought had gone into the design and it was finally decided that indeed something more ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("powerful than a ship with six 11in guns was needed to meet the French pair. Hitler had been in negotiations with Great Britain and the result was the Anglo-German naval agreement of 1935 in which Germany was allowed to build up to 35 per cent of the Royal Navy’s tonnage by type. By 1934 the outcome looked promising so on 5 July 1934 work stopped and the keels were scrapped. The contracts were not cancelled; instead a new larger design would be built.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_2_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("The ships carried nine 11in guns (formally called 28cm, but actually 283mm) SK C34 in triple Drhl C34 turrets that were virtually identical to those mounted in the panzerschiffe. This view shows "), _c('i', [_vm._v("Scharnhorst")]), _vm._v("’s ‘A’ and ‘B’ turrets (known in German naval parlance as Anton and Bruno – ‘C’ was Caesar). On pre-war German warships the turrets were also given individual names celebrating naval tradition, in this case ‘Graf Spee’ and ‘Gneisenau’, and the cast shields that can be seen beneath the rangefinder housings carried the coats of arms of those officers’ families.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-title"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/box.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("DESIGN CHARACTERISTICS")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Dimensions")]), _vm._v(" "), _c('i', [_vm._v("As Built:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Length 754ft (229.8m) oa; 741ft 5in (226m) wl. Beam 98ft 5in (30m)."), _c('br'), _vm._v("Draught 27ft (8.23m) mean (designed); 32ft 7in (9.93m) maximum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("With Atlantikstem:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Length 772ft 4in (235.4m) oa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Displacement")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("26,000 tons standard (official)"), _c('br'), _vm._v("34,841 tons normal load"), _c('br'), _vm._v("38,900 tons full load")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Armament")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Nine 11in (280mm) guns (3x3); twelve 5.9in (150mm) guns (4x2,4x1); fourteen 4.1in (105mm) heavy AA guns (7x2); sixteen 37mm medium AA guns (8x2); eight single 20mm light AA guns (8x1); six 21in (533mm) torpedo tubes (3x2) added 1941/42")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Vertical Armour")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Main belt 320-170mm; conning tower 450-200mm; main turrets 360-150mm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Horizontal Armour")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Main armoured deck 150mm; upper armoured deck 50mm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Machinery")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Three high pressure turbines; twelve small water tube boilers, 160,000shp maximum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Maximum Speed")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("31.65kts "), _c('i', [_vm._v("Scharnhorst;")]), _vm._v(" 30.7kts "), _c('i', [_vm._v("Gneisenau")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_3.jpg"
    }
  })])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The first of the new construction was to be much larger than the improved panzer-schiffe design but, so as not to antagonize the British, it was still to carry 11in guns. Perhaps more important to the decision was the fact that of all systems which determined the building time of a battleship, armament took the longest to develop. To use any heavier gun would have added significantly to the building period. The German navy had been developing a new 15in gun but it was far from ready for deployment, so it would be far quicker to use the same armament as the "), _c('i', [_vm._v("Deutschland")]), _vm._v(" class, the triple 11in gun turret for the new ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("design, but with three turrets instead of two. Furthermore, the turrets were already on order for the fourth and fifth of the panzerschiffe. There was still support for 15in guns for the pair but as a compromise the barbettes for the triple 11in mounting were to be of the same dimensions as the new twin 15in turret design, allowing subsequent replacement. Accordingly, the new design was a political and practical compromise, driven by the need for speedy construction.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_3_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Scharnhorst")]), _vm._v(" on 20 April 1939 dressed overall to celebrate Adolf Hitler’s birthday.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Gneisenau")]), _vm._v("’s forecastle and forward turrets from a bridge platform, spring 1940. Note the periscope sights on the roof of the conning tower, and the open navigation bridge around it. These ships had extending bridge wings to facilitate close-quarter manoeuvring that were hinged back against the superstructure when at sea.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_4_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("Bridge and forward turrets of "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(", probably about November 1939. At this point, the ship still has not had the FuMO 22 radar added.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_4_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("Even as refitted, "), _c('i', [_vm._v("Gneisenau")]), _vm._v("’s anchors continued to be a serious source of spray at sea and eventually they were moved to sloping beds on the deck edge and the traditional hawse pipes were plated over. During this process the two portside anchors were reduced to one. This photo from sea level shows the new configuration in "), _c('i', [_vm._v("Gneisenau")]), _vm._v(" in the summer of 1939.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The decision to continue carrying singlepurpose 150mm (5.9in) secondary guns for surface action instead of dual-purpose surface/AA guns can be criticized. It is true that the USN was developing DP 5in guns for their new battleship designs and the Royal Navy 5.25in guns for their new "), _c('i', [_vm._v("(King George V")]), _vm._v(") design, but the Japanese clung to surface action 6.1in guns for the "), _c('i', [_vm._v("Yamato")]), _vm._v(" and the Italians and French also kept single-purpose secondaries for their new designs. The German 4.1in DP gun would have been considered too light in the surface role for battleship secondary armament by everyone but the few visionaries that foresaw the dominance of airpower in future conflicts. The German navy had very few, if any, of such visionaries on its staff. There certainly was no time to design a completely new dual-purpose gun heavier than the 4.1in.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The two ships were named "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" and "), _c('i', [_vm._v("Gneisenau")]), _vm._v(", perpetuating the names of Admiral von Spee’s two armoured cruisers of the First World War. Many references call these ships battlecruisers because of their light 11in gun armament but they were officially called ‘schlachtschiffe’ (battleships) and also continued German battleship design preferences from the Great World. Battleships of the Imperial German Navy mounted lighter guns than battleships of the Royal Navy but had much superior protection; ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("and with the new "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" design, they were also much faster. The designers’ first choice was diesel engines but they could not provide the desired maximum speed of 31kts. As a consequence, it was decided to use a newly designed high-pressure steam plant that would provide the power for high speed but resulted in a greatly reduced radius of action compared to the diesel-powered panzerschiffe. This highpressure power plant never met expectations and proved to be a weakness in all heavy ships in which it was installed, such as the "), _c('i', [_vm._v("Hipper")]), _vm._v(" class, in that it tended to break down frequently. The power plant developed 125,000shp and "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" was slightly faster than her sister: she clocked in at 31.65kts on trials while "), _c('i', [_vm._v("Gneisenau")]), _vm._v(" reached 30.7kts. Range was less than expected at 7100nm for "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" (6200nm for "), _c('i', [_vm._v("Gneisenau")]), _vm._v(") instead of the designed 8200nm at 19kts. For public purposes the displacement said to be 26,000 tons but, as was the case with other German designs, actual displacement was far greater. "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" had a standard displacement of 34,780 tons and deep load (operational) displacement of 41,757 tons. As designed and built, the pair followed the same ‘family’ appearance as the panzerschiffe, with an almost straight cutwater, tower superstructure and single flat-topped funnel.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_5_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("The "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" benefited from the experience gained with her sister and between June and August 1939 was similarly modified forward, but with the addition of a stemhead anchor, prefiguring the system adopted in "), _c('i', [_vm._v("Bismarck")]), _vm._v(" and "), _c('i', [_vm._v("Tirpitz")]), _vm._v(". However, the refit was more radical and included the installation of a new tripod mainmast aft of the hangar, and thereafter the sisters were easily distinguishable. Note that the funnel cap was also less raked.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The pair were 754ft (229.8m) long with their original straight stem and added another 16ft when fitted with the overhanging so-called Atlantik bow. They had a beam of 98ft 5in (30m) and draught of 27ft (8.23m). The main armour belt was 13.8in tapering to 7.9in (350-200mm). Maximum turret armour was 14.2in, 9in thicker than the "), _c('i', [_vm._v("Deutschland")]), _vm._v(" turrets. Barbette maximum armour was 13.8in, as was conning tower armour. The "), _c('i', [_vm._v("Gneisenau")]), _vm._v(" was laid down on 6 May 1935 followed by "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" on 15 June 1935, but "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" was faster in construction and was launched 3 October 1936 by the widow of the captain of the First World War "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(", with Hitler present, while "), _c('i', [_vm._v("Gneisenau")]), _vm._v(" was launched on 8 December 1936 by the widow of the captain of the armoured cruiser "), _c('i', [_vm._v("Gneisenau")]), _vm._v(". However, "), _c('i', [_vm._v("Gneisenau")]), _vm._v(" commissioned first, on 28 May 1938 followed by "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" on 7 January 1939. The fitting-out schedule for "), _c('i', [_vm._v("Scharnhorst")]), _vm._v(" was slowed by increasing demands on the yard’s capacity, as the quantity of all types of warships was expanding rapidly.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_5_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Scharnhorst")]), _vm._v(" in September 1939. Two of the Arado Ar 196 floatplanes, then newly entering service, can be seen on the catapults. The aircraft on ‘C’ turret was clearly very vulnerable to blast and weather damage and that catapult was soon removed from both ships.")])])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c67e53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 69
// module chunks = 0